export default {
  presenter: 'bedrich',
  title: 'apt install python3 # a co dál?',
  subtitle: 'začátečníci',
  text: `
Výborně, Python jste již nainstalovali. A co dál?  
Jak (a proč) vytvořit virtualenv, jak nainstalovat cizí balíček, jaký editor následně otevřít a
jak pomocí něj napsat, otestovat a spustit jednoduchý program?  
Na tyto a možná i další otázky se pokusím odpovědět v tomto nakopávacím talku.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/bedrich-python.js